import { focusQuantity, validateFocusAmount } from '@theme/fm-focus-contribution';

export function validateProgramContribution(form) {
  const choice = form?.querySelector('[data-fm-program-choice]')?.value;
  return !['focus', 'both'].includes(choice) || validateFocusAmount(form.querySelector('[data-fm-focus-amount]'));
}

export function programContributionItems(form) {
  const choice = form.querySelector('[data-fm-program-choice]')?.value;
  const programs = choice === 'both' ? ['focus', 'ggm'] : ['focus', 'ggm'].includes(choice) ? [choice] : [];
  return programs.flatMap(program => {
    if (program === 'focus') {
      const input = form.querySelector('[data-fm-focus-amount]');
      const quantity = input && focusQuantity(input.value);
      return quantity ? [{ id: input.dataset.fmFocusVariant, quantity }] : [];
    }
    const select = form.querySelector(`[data-fm-program-amount="${program}"]`);
    const option = select?.selectedOptions[0];
    return option?.value && !option.disabled ? [{ id: option.value, quantity: 1 }] : [];
  });
}

if (typeof document !== 'undefined') {
  document.addEventListener('change', event => {
    if (!event.target.matches?.('[data-fm-program-choice]')) return;
    const root = event.target.closest('[data-fm-program-support]');
    for (const label of root.querySelectorAll('[data-fm-program-field]')) {
      const active = event.target.value === 'both' || event.target.value === label.dataset.fmProgramField;
      label.hidden = !active;
      label.querySelectorAll('select, input').forEach(input => { input.disabled = !active; });
    }
  });
  document.querySelectorAll('[data-fm-program-field="focus"] input').forEach(input => { input.disabled = input.closest('[data-fm-program-field]').hidden; });
}
